import { createStylesContext } from '@chakra-ui/react'

const [_StylesProvider, useStyles] = createStylesContext('LoginAndSignUp')

export const StylesProvider = _StylesProvider
export const useLoginAndSignUpStyles = useStyles
